module.exports = __webpack_public_path__ + "apple-icon-60x60.5277b2d6.png";